<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g data-name="Ico_grid view_sel"><path data-name="합치기 386" d="M19385.3-2761a1 1 0 0 1-1-1v-4.234a1 1 0 0 1 1-1h4.229a1 1 0 0 1 1 1v4.234a1 1 0 0 1-1 1zm-7.771 0a1 1 0 0 1-1-1v-4.234a1 1 0 0 1 1-1h4.229a1 1 0 0 1 1 1v4.234a1 1 0 0 1-1 1zm7.771-7.772a1 1 0 0 1-1-1v-4.229a1 1 0 0 1 1-1h4.229a1 1 0 0 1 1 1v4.229a1 1 0 0 1-1 1zm-7.771 0a1 1 0 0 1-1-1v-4.229a1 1 0 0 1 1-1h4.229a1 1 0 0 1 1 1v4.229a1 1 0 0 1-1 1z" transform="translate(-19375.533 2775.996)" /></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-grid-view-new',
});
</script>